import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressBook,
  faBasketShopping,
  faBell,
  faCalculator,
  faCashRegister,
  faCircleMinus,
  faLayerGroup,
  faListOl,
  faMagnifyingGlassChart,
  faMessage,
  faNetworkWired,
  faObjectGroup,
  faPersonCirclePlus,
  faPersonWalkingLuggage,
  faHome,
} from "@fortawesome/free-solid-svg-icons";
import { saveVariableGlo } from "../actions/chariotActions";
import { useSelector, useDispatch } from "react-redux";
import { listeClients, logout } from "../actions/clientsActions";
import { listeSocietes } from "../actions/societeActions";
import { messagesListe } from "../actions/messageActions";
import "../DemAdmin.css";

const DemAdmin = () => {
  const chListe = useSelector((state) => state.chariot);
  const { varGlo } = chListe;
  const cli = useSelector((state) => state.client);
  const { client } = cli;
  const CListe = useSelector((state) => state.clientsListeState);
  const { clients } = CListe;
  const [tabRep, setTabRep] = useState([]);
  const listeSoc = useSelector((state) => state.listeSocietes);
  const { societes } = listeSoc;
  const [x, setX] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const mliste = useSelector((state) => state.msg_distant);
  const { msg } = mliste;
  const params = location.state || {};

  const totmsg = () => {
    let n = 0;
    msg?.forEach((m) =>
      m?.tokens?.forEach((t) => t?.value === client?.nom_cli && n++)
    );
    return n;
  };

  const listeRep = () => {
    clients?.forEach((cli) => {
      if (client?.nivcli_cloud == "A") {
        setTabRep((tabRep) => [...tabRep, cli]);
      }
    });
  };

  useEffect(() => {
    const handleBackButton = (e) => {
      e.preventDefault();
      if (window.confirm("Veuillez Vous Quitter?")) {
        window.close();
      }
    };

    window.addEventListener("popstate", handleBackButton);
    return () => window.removeEventListener("popstate", handleBackButton);
  }, []);

  useEffect(() => {
    if (!client) {
      navigate("/");
    } else {
      localStorage.setItem(
        "persist",
        client?.persist == true ? "true" : "false"
      );
      dispatch(listeClients());
      dispatch(messagesListe());

      if (client?.nom_cli == "google") {
        dispatch(saveVariableGlo(client));
      }

      setTabRep([]);
      if (x == 0) {
        listeRep();
      }

      document.title = `${
        client?.nivcli_cloud == "A" ? "Administrateur" : "Resp Inv Locale"
      }: ${client?.nom_cli}`;
    }
  }, [location, client]);

  const deconnexionHandler = () => {
    dispatch(logout());
    navigate("/");
    setTabRep([]);
  };

  const renderAdminButtons = () => (
    <>
      <MenuButton
        icon={faPersonWalkingLuggage}
        text="Saisie Commande Client"
        onClick={() => {
          navigate("/RechClient", { state: { langue: params.langue } });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faAddressBook}
        text="Liste Représantants"
        onClick={() => {
          navigate("/RechRepres", {
            state: { langue: params.langue, crit: "det" },
          });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faObjectGroup}
        text="Famille Article"
        onClick={() => {
          navigate("/ListeFamille", {
            state: { langue: params.langue, wcli: varGlo },
          });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faMagnifyingGlassChart}
        text="Analyse Article/Famille"
        onClick={() => {
          navigate("/liste-famille-admin", {
            state: { langue: params.langue, wcli: varGlo },
          });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faListOl}
        text="Liste Commandes Clients"
        onClick={() => {
          navigate("/RepresDetail", { state: { code: "tous" } });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faPersonCirclePlus}
        text="Creation Nouveau Client"
        onClick={() => {
          navigate("/AjoutClient", { state: { societe: params.societe } });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faCalculator}
        text="M.A.J Inventaire Article"
        onClick={() => {
          navigate("/work-nav", { state: { societe: params.societe } });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faBasketShopping}
        text="Liste Article"
        onClick={() => {
          navigate("/ToutArticles", {
            state: { societe: params.societe },
          });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faCircleMinus}
        text="Liste Articles Stock Negatif"
        onClick={() => {
          navigate("/ArticleListeStockNegative", {
            state: { societe: params.societe },
          });
          setTabRep([]);
        }}
      />
      {/* <MenuButton
        icon={faMessage}
        text="Envoie reclamation"
        onClick={() => {
          navigate("/MessageDistant", {
            state: { langue: params.langue, societe: params.societe },
          });
          setTabRep([]);
        }}
      />*/}
      <MenuButton
        icon={faCashRegister}
        text="Caisse du jour"
        onClick={() => {
          navigate("/rech-list-caissier", {
            state: { langue: params.langue, societe: params.societe },
          });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faNetworkWired}
        text="Déconnexion"
        onClick={deconnexionHandler}
      />
    </>
  );

  const renderLocalAdminButtons = () => (
    <>
      <MenuButton
        icon={faHome}
        text="M.A.J Inventaire Article Locale"
        onClick={() => {
          navigate("/work-nav-loc", { state: { societe: params.societe } });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faMagnifyingGlassChart}
        text="Analyse Article/Locale"
        onClick={() => {
          navigate("/analyse-art-famille-oracle", {
            state: { langue: params.langue, wcli: varGlo },
          });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faNetworkWired}
        text="Déconnexion"
        onClick={deconnexionHandler}
      />
    </>
  );

  const renderArabicButtons = () => (
    <>
      <MenuButton
        icon={faLayerGroup}
        text="قــــائـــمة مــــاركــات البـضاعـــة"
        isRTL
        onClick={() => {
          navigate("/marque-liste", {
            state: { langue: params.langue, wcli: varGlo },
          });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faObjectGroup}
        text="قــــائـــمة عــائلات البـــــضاعـــة"
        isRTL
        onClick={() => {
          navigate("/famille-liste", {
            state: { langue: params.langue, wcli: varGlo },
          });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faListOl}
        text="قـــــــائـــــــــمة الطلبيـــات"
        isRTL
        onClick={() => {
          navigate("/liste-commandes-rep");
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faPersonCirclePlus}
        text="اظافة حريف"
        isRTL
        onClick={() => {
          navigate("/ajout-client", { state: { societe: params.societe } });
          setTabRep([]);
        }}
      />
      <MenuButton
        icon={faMessage}
        text="مراسلة"
        isRTL
        onClick={() => {
          navigate("/liste-messages", { state: { langue: params.langue } });
          setTabRep([]);
        }}
      />
    </>
  );

  const renderEnglishButtons = () => (
    <>
      <MenuButton
        icon={faLayerGroup}
        text="Product Categorie"
        onClick={() =>
          navigate("/marque-liste", { state: { langue: params.langue } })
        }
      />
      <MenuButton
        icon={faObjectGroup}
        text="Product Family"
        onClick={() =>
          navigate("/famille-liste", { state: { langue: params.langue } })
        }
      />
      <MenuButton
        icon={faListOl}
        text="My Orders"
        onClick={() => navigate("/liste-commandes-rep")}
      />
      <MenuButton
        icon={faPersonCirclePlus}
        text="Client Creation"
        onClick={() => navigate("/ajout-client")}
      />
      <MenuButton
        icon={faMessage}
        text="Contact"
        onClick={() => navigate("/liste-commandes-rep")}
      />
    </>
  );

  return (
    <div className={"admin-container"}>
      <div
        className="background-image"
        //style={{ backgroundImage: "url('../ecran-demarrage.jpeg')" }}
      >
        <div className="scroll-container">
          <div className="header-demadmin">
            <div className="company-name">{societes[0]?.nom_soc}</div>
            <div className="app-name">منصة الطلبيات</div>
          </div>

          <div className="menu-container">
            {params.langue === "F"
              ? client?.nivcli_cloud === "A"
                ? renderAdminButtons()
                : renderLocalAdminButtons()
              : params.langue === "A"
              ? renderArabicButtons()
              : renderEnglishButtons()}
          </div>
        </div>

        <div
          className="notification-button"
          onClick={() => navigate("/notification-client")}
        >
          <FontAwesomeIcon icon={faBell} size="lg" />
          {totmsg() > 0 && (
            <div className="notification-badge">
              <span className="notification-text">{totmsg()}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const MenuButton = ({ icon, text, onClick, isRTL = false }) => (
  <button
    className={`menu-button ${isRTL ? "rtl-button" : ""}`}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={icon} size="2x" className="menu-icon" />
    <span className="menu-text">{text}</span>
  </button>
);

export default DemAdmin;
